import { gql } from 'urql';

// SoftPull Credit Check
const LineOfCreditSoftCreditCheck = gql`
  mutation lineOfCreditSoftCreditCheck($idempotencyId: String!) {
    lineOfCreditSoftCreditCheck(idempotencyId: $idempotencyId) {
      ... on LineOfCreditSoftCreditCheckError {
        code
        message
        title
      }
      ... on LineOfCreditSoftCreditCheckSuccess {
        registrationInfoId
      }
    }
  }
`;

export default LineOfCreditSoftCreditCheck;
